import { CellValue, TableColumnSpec, TableRow } from './types';

export function cellNumber(row: TableRow, id: string): number | null {
  const v = row[id];
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : Number(String(v).trim());
  return Number.isFinite(n) ? n : null;
}

/** Coerce raw text (a typed cell, a pasted CSV field) to what the column accepts. */
export function coerceCell(spec: TableColumnSpec, raw: string): CellValue {
  const text = raw.trim();
  if (text === '') return null;
  if (spec.type === 'number') {
    const n = Number(text.replace('−', '-'));
    return Number.isFinite(n) ? n : text;
  }
  if (spec.type === 'integer') {
    const n = Number.parseInt(text, 10);
    return Number.isFinite(n) ? n : text;
  }
  return text;
}

/** Keep only the declared columns, coercing each. Unknown keys are dropped so stored rows match the spec. */
export function normalizeRow(columns: TableColumnSpec[], raw: unknown): TableRow {
  const source = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>;
  const row: TableRow = {};
  for (const column of columns) {
    const value = source[column.id];
    if (value === null || value === undefined) row[column.id] = null;
    else if (typeof value === 'number') row[column.id] = column.type === 'string' || column.type === 'choice' ? String(value) : value;
    // files or anything else structured, e.g. a cell stored when the column took uploads: nothing a typed cell can hold
    else if (typeof value === 'object') row[column.id] = null;
    else row[column.id] = coerceCell(column, String(value));
  }
  return row;
}

export function normalizeRows(columns: TableColumnSpec[], raw: unknown): TableRow[] {
  if (!Array.isArray(raw)) return [];
  return raw.map((r) => normalizeRow(columns, r));
}
